import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_EncounterMetadata } from '@app/advisor-shared';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_BaseAdvisorRuntime } from '../../modules/ModuleFE_BaseAdvisorRuntime.js';
import { ModuleFE_AdvisorSession } from '../advisor-session/ModuleFE_AdvisorSession.js';
export const dispatch_onEncounterMetadataUpdated = new ThunderDispatcherV3('__onEncounterMetadataUpdated');
export class ModuleFE_EncounterMetadata_Class extends ModuleFE_BaseAdvisorRuntime {
    constructor() {
        super(DBDef_EncounterMetadata, dispatch_onEncounterMetadataUpdated);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.patientFilter);
    }
    getEncounterMetadata = () => {
        const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
        if (!encounterId)
            throw new MUSTNeverHappenException(`Trying to get Encounter but can't get current encounterId!`);
        return this.cache.find(encounter => encounter._id === encounterId);
    };
    async clearEncounterDataFromIDB(encounterId) {
        if (!encounterId) {
            this.logError(`Couldn't find encounterId to clean from IDB`);
            return;
        }
        await this.IDB.storeWrapper.deleteAll([{ _id: encounterId }]);
    }
}
export const ModuleFE_EncounterMetadata = new ModuleFE_EncounterMetadata_Class();
//# sourceMappingURL=ModuleFE_EncounterMetadata.js.map